(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[41],{

/***/ "+uRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationFavorite", function() { return NavigationFavorite; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ma9I");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TeQF");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fbCW");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2B1R");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("+2oP");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("07d7");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("JfAA");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("uDfI");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("Ub5k");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("DqI1");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("6jSF");
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("U2CP");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("qqKu");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("UCZK");
/* harmony import */ var _product_banner_ProductBanner__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("SUcU");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("kiXb");
/* harmony import */ var _context_FavoriteProductListContext__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("XGb2");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_price_Price__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("IuYR");
/* harmony import */ var _store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("VO7D");
/* harmony import */ var _store_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("+mhw");
/* harmony import */ var _store_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("fflk");
/* harmony import */ var _store_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("C5R2");
/* harmony import */ var _store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("1bWg");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("Sj1w");
/* harmony import */ var _frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__("Ohju");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__("i5Mr");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__("1JJ2");
/* harmony import */ var _hooks_use_authentication_useAuthentication__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__("Iev9");
/* harmony import */ var _price_remote_price_remote_favorite_favorite_utils__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__("KE+3");
/* harmony import */ var _utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__("aWOT");








var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;

/* eslint-disable clubmed/no-fake-component */

































var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_19__["constants"].NO_TRANSPORT_VALUE;

var removeFromFavorites = function removeFromFavorites(_ref) {
  var isConnected = _ref.isConnected,
      removeFavoriteProduct = _ref.removeFavoriteProduct,
      indexToRemove = _ref.indexToRemove,
      favoriteProductList = _ref.favoriteProductList,
      onClose = _ref.onClose,
      setFavoriteProductList = _ref.setFavoriteProductList;
  var favoriteProductToRemove = favoriteProductList.find(function (_, idx) {
    return idx === indexToRemove;
  }) || {};
  var storeFavoriteProductList = favoriteProductList.filter(function (_, idx) {
    return idx !== indexToRemove;
  });

  if (isConnected) {
    removeFavoriteProduct(favoriteProductToRemove);
  }

  setFavoriteProductList(storeFavoriteProductList, false, false);

  if (!storeFavoriteProductList.length) {
    onClose();
  }
};

var renderFavorite = function renderFavorite(favoriteProduct) {
  var _favoriteProduct$kids, _favoriteProduct$kids2, _favoriteProduct$pric, _favoriteProduct$pric2, _favoriteProduct$pric3, _favoriteProduct$pric4;

  var hasTransport = !!favoriteProduct.departureCity && favoriteProduct.departureCity !== NO_TRANSPORT_VALUE;
  var formattedTripDuration = "".concat(favoriteProduct.departureDate && moment__WEBPACK_IMPORTED_MODULE_11___default()(favoriteProduct.departureDate).format('DD MMM'), " - ").concat(favoriteProduct.duration && moment__WEBPACK_IMPORTED_MODULE_11___default()(favoriteProduct.departureDate).add({
    days: favoriteProduct.duration
  }).format('DD MMM'), " ").concat(favoriteProduct.duration && "(".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('booking.form.selectDuration', {
    duration: favoriteProduct.duration
  }), ")"));
  var formattedParticipants = "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('booking.form.selectAdultsLabels', {
    count: favoriteProduct.adultsNumber
  })).concat(((_favoriteProduct$kids = favoriteProduct.kids) === null || _favoriteProduct$kids === void 0 ? void 0 : _favoriteProduct$kids.length) !== 0 ? " - ".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('booking.form.selectChildrenLabels', {
    count: (_favoriteProduct$kids2 = favoriteProduct.kids) === null || _favoriteProduct$kids2 === void 0 ? void 0 : _favoriteProduct$kids2.length
  })) : '');
  return __jsx(react__WEBPACK_IMPORTED_MODULE_8__["Fragment"], null, __jsx(_product_banner_ProductBanner__WEBPACK_IMPORTED_MODULE_24__[/* ProductBanner */ "a"], {
    className: "mb-5",
    product: favoriteProduct.product
  }), __jsx("div", {
    className: "flex justify-between items-center py-5"
  }, __jsx("span", {
    className: "flex gap-10 items-center"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].DATE,
    width: "calc(16rem / 16)"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.dateLabel')), __jsx("span", null, formattedTripDuration)), __jsx("div", {
    className: "flex justify-between items-center py-5"
  }, __jsx("span", {
    className: "flex gap-10 items-center"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].PEOPLE_DOUBLE,
    width: "calc(16rem / 16)"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.participantsLabel')), __jsx("span", {
    className: "ml-10"
  }, formattedParticipants)), __jsx("div", {
    className: "flex justify-between items-center py-5"
  }, __jsx("span", {
    className: "flex gap-10 items-center"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    name: hasTransport ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRANSPORT : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].NO_TRANSPORT,
    width: "calc(16rem / 16)"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.transportLabel')), __jsx("span", null, hasTransport ? favoriteProduct.departureCity : Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.transport.withoutTransportLabel'))), ((_favoriteProduct$pric = favoriteProduct.priceOfStay) === null || _favoriteProduct$pric === void 0 ? void 0 : _favoriteProduct$pric.bestPrice) && __jsx("div", {
    className: "mt-5 pt-10 border-t-1 border-lightGrey flex items-start justify-between"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.price.totalLabel'), __jsx(_frameworks_price_Price__WEBPACK_IMPORTED_MODULE_28__[/* Price */ "a"], {
    bestPrice: (_favoriteProduct$pric2 = favoriteProduct.priceOfStay) === null || _favoriteProduct$pric2 === void 0 ? void 0 : _favoriteProduct$pric2.bestPrice,
    className: "text-20 text-end",
    from: ((_favoriteProduct$pric3 = favoriteProduct.priceOfStay) === null || _favoriteProduct$pric3 === void 0 ? void 0 : _favoriteProduct$pric3.bestPrice) ? Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('price.format.from') : '',
    hasAsterisk: false,
    hasTotalPrice: true,
    initialPrice: (_favoriteProduct$pric4 = favoriteProduct.priceOfStay) === null || _favoriteProduct$pric4 === void 0 ? void 0 : _favoriteProduct$pric4.initialPrice
  })));
};

var getPlaceholders = function getPlaceholders(numberOfItems) {
  var placeholders = [];

  for (var i = 0; i < numberOfItems; i++) {
    placeholders.push(__jsx("div", {
      className: "border-1 border-dashed border-lightGrey rounded-12 relative h-0 my-20",
      key: i,
      style: {
        paddingBottom: 'calc(240 / 425 * 100%)'
      }
    }, __jsx("div", {
      className: "absolute inset-0 flex items-center justify-center text-center text-12 text-grey p-15"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.favoriteOption.allMyFavorites.emptyFavorites'))));
  }

  return placeholders;
};

var NoFavoritesView = function NoFavoritesView(_ref2) {
  var onClose = _ref2.onClose;
  return __jsx(react__WEBPACK_IMPORTED_MODULE_8__["Fragment"], null, __jsx("div", {
    className: "text-12 mb-0 font-bold flex gap-5 justify-between items-center"
  }, __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.favoriteOption.noFavoritesPopin.title')), __jsx("button", {
    className: "leading-tighter",
    "data-testid": "CTA-close-no-favorite-view",
    onClick: onClose,
    type: "button"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CROSS,
    width: "calc(13rem / 16)"
  }))), __jsx("div", {
    className: "text-12 p-25 pb-10 text-center"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    className: "m-20",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].STAR_HOLLOW,
    width: "calc(32rem / 16)"
  }), __jsx("div", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.favoriteOption.favoriteTooltip.title')), __jsx("div", {
    className: "text-black mt-25"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.favoriteOption.noFavoritesPopin.consult'))));
};

var LatestAddedProductView = function LatestAddedProductView(_ref3) {
  var favoriteProduct = _ref3.favoriteProduct,
      onButtonClick = _ref3.onButtonClick,
      onClose = _ref3.onClose;

  var _useTrackEvent = Object(_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_14__[/* useTrackEvent */ "a"])(),
      trackClickEvent = _useTrackEvent.trackClickEvent;

  return __jsx(react__WEBPACK_IMPORTED_MODULE_8__["Fragment"], null, __jsx("div", {
    className: "text-12 mb-0 font-bold flex gap-5 justify-between items-center"
  }, __jsx("span", {
    className: "flex gap-10 items-center"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_23__[/* COLORS */ "a"].SUCCESS,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CHECK,
    width: "calc(14rem / 16)"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.favoriteOption.favoritesPopin.title')), __jsx("button", {
    className: "leading-tighter",
    "data-testid": "CTA-close-favorite-view",
    onClick: onClose,
    type: "button"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CROSS,
    width: "calc(13rem / 16)"
  }))), __jsx("div", {
    className: "mt-25 overflow-hidden text-12"
  }, renderFavorite(favoriteProduct)), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_21__[/* Text */ "a"], {
    className: "text-black text-center text-12 mt-10",
    text: "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.favoriteOption.favoritesPopin.reassuranceLabel')),
    theme: "none"
  }), __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_27__[/* Button */ "a"], {
    className: "mt-25 w-full",
    dataTestId: "CTA-see-all-favorite",
    onClick: function onClick() {
      trackClickEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_13__[/* TRACK_EVENT_NAMES */ "E"].CLICK_HEADER, {
        detail_click: 'travel_plans_see_all'
      });
      onButtonClick();
    }
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.favoriteOption.favoritesPopin.button')));
};

var AllFavoriteProductView = function AllFavoriteProductView(_ref4) {
  var favoriteProductList = _ref4.favoriteProductList,
      numberOfProducts = _ref4.numberOfProducts,
      onClose = _ref4.onClose,
      setFavoriteProductList = _ref4.setFavoriteProductList;
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_9__[/* useDispatch */ "d"])();

  var _useAuthentication = Object(_hooks_use_authentication_useAuthentication__WEBPACK_IMPORTED_MODULE_38__[/* useAuthentication */ "a"])(),
      isLogged = _useAuthentication.isLogged;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_37__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var appContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_12__[/* useAppContext */ "c"])();

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_10__["useRouter"])(),
      asPath = _useRouter.asPath;

  var origin = new urijs__WEBPACK_IMPORTED_MODULE_18___default.a(appContext.originalUrl).origin();
  var currentUri = new urijs__WEBPACK_IMPORTED_MODULE_18___default.a(origin + asPath);

  var _useTrackEvent2 = Object(_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_14__[/* useTrackEvent */ "a"])(),
      trackClickEvent = _useTrackEvent2.trackClickEvent;

  var numberOfPlaceHolders = _tracking_constants__WEBPACK_IMPORTED_MODULE_13__[/* SHOPPING_FAVORITE_PRODUCTS_NUMBER_MAX */ "w"] - numberOfProducts;
  return __jsx(react__WEBPACK_IMPORTED_MODULE_8__["Fragment"], null, !isDesktop && __jsx("div", {
    className: "flex justify-end -mt-10"
  }, __jsx("button", {
    onClick: onClose,
    type: "button"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CROSS,
    width: "calc(16rem / 16)"
  }))), !isLogged && __jsx("div", {
    className: "flex gap-20 items-center my-20 p-15 rounded-12 shadow-subtle text-12"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
    className: "text-black",
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].STAR_HOLLOW,
    width: "calc(26rem / 16)"
  }), __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_36__[/* default */ "a"], {
    className: "text-black cursor-default",
    onClick: function onClick() {
      trackClickEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_13__[/* TRACK_EVENT_NAMES */ "E"].CLICK_HEADER, {
        detail_click: 'travel_plans_sign_up'
      });
    },
    url: _utils_ple_utils__WEBPACK_IMPORTED_MODULE_16__[/* buildSigninUrl */ "f"]({
      locale: appContext.locale
    })
  }, __jsx(_frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_35__[/* TemplateString */ "a"], {
    template: Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.favoriteOption.allMyFavorites.incentive'),
    values: {
      signIn: Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.favoriteOption.allMyFavorites.signIn')
    },
    valuesClassName: {
      signIn: 'text-black underline cursor-pointer'
    }
  }))), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_21__[/* Text */ "a"], {
    className: "text-black text-center text-12 py-5",
    text: "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.favoriteOption.favoritesPopin.reassuranceLabel')),
    theme: "none"
  }), favoriteProductList.slice(0, _tracking_constants__WEBPACK_IMPORTED_MODULE_13__[/* SHOPPING_FAVORITE_PRODUCTS_NUMBER_MAX */ "w"]).map(function (favoriteProduct, favoriteProductIndex) {
    var _URI$setQuery;

    var adultsNumber = favoriteProduct.adultsNumber,
        departureCity = favoriteProduct.departureCity,
        departureDate = favoriteProduct.departureDate,
        duration = favoriteProduct.duration,
        kids = favoriteProduct.kids,
        kidsValidationState = favoriteProduct.kidsValidationState,
        product = favoriteProduct.product;
    var resortPageUrl = new urijs__WEBPACK_IMPORTED_MODULE_18___default.a(product.href).setQuery((_URI$setQuery = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_URI$setQuery, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_34__[/* QUERY_DEPARTURE_DATE */ "g"], departureDate && moment__WEBPACK_IMPORTED_MODULE_11___default()(departureDate).format(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_34__[/* QUERY_DATE_FORMAT */ "f"])), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_URI$setQuery, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_34__[/* QUERY_DURATION */ "h"], duration), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_URI$setQuery, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_34__[/* QUERY_KIDS */ "j"], (kids === null || kids === void 0 ? void 0 : kids.length) > 0 && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_15__[/* serializeKidsToQueryParam */ "o"])({
      kids: kids,
      kidsValidationState: kidsValidationState
    }) || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_URI$setQuery, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_34__[/* QUERY_NUMBER_OF_ADULTS */ "l"], adultsNumber), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_URI$setQuery, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_34__[/* QUERY_TRANSPORT */ "m"], departureCity), _URI$setQuery));
    return __jsx("div", {
      key: favoriteProductIndex,
      className: "p-15 my-20 rounded-12 shadow-subtle text-12"
    }, __jsx("div", {
      className: "flex justify-end"
    }, __jsx("button", {
      "data-testid": "CTA-remove-favorite",
      onClick: function onClick() {
        removeFromFavorites({
          isConnected: isLogged,
          removeFavoriteProduct: function removeFavoriteProduct(favoriteProductToRemove) {
            return favoriteProductToRemove.origin === 'BOOKMARK' ? Object(_price_remote_price_remote_favorite_favorite_utils__WEBPACK_IMPORTED_MODULE_39__[/* deleteBookmarkMutation */ "b"])(favoriteProductToRemove.id, appContext) : Object(_price_remote_price_remote_favorite_favorite_utils__WEBPACK_IMPORTED_MODULE_39__[/* deleteCustomerProposalMutation */ "c"])(favoriteProductToRemove.id, appContext);
          },
          indexToRemove: favoriteProductIndex,
          favoriteProductList: favoriteProductList,
          onClose: onClose,
          setFavoriteProductList: setFavoriteProductList
        });
        trackClickEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_13__[/* TRACK_EVENT_NAMES */ "E"].CLICK_HEADER, {
          detail_click: 'travel_plans_remove'
        });
      },
      type: "button"
    }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_20__[/* Icon */ "a"], {
      name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CROSS,
      width: "calc(13rem / 16)"
    }))), __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_36__[/* default */ "a"], {
      className: "block overflow-hidden",
      onClick: function onClick() {
        onClose();
        trackClickEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_13__[/* TRACK_EVENT_NAMES */ "E"].CLICK_HEADER, {
          detail_click: 'travel_plans_open'
        });
        Object(react_redux__WEBPACK_IMPORTED_MODULE_9__[/* batch */ "b"])(function () {
          dispatch(Object(_store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_29__[/* setAdultsNumber */ "a"])(adultsNumber));
          dispatch(Object(_store_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_30__[/* setDepartureCity */ "a"])({
            value: departureCity
          }));
          dispatch(Object(_store_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_31__[/* setDepartureDate */ "a"])(departureDate));
          dispatch(Object(_store_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_32__[/* setDuration */ "a"])(duration));
          dispatch(Object(_store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_33__[/* setKids */ "b"])(kids));
        });
      },
      url: favoriteProduct.reference ? Object(_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_40__[/* getBookingEngineUrl */ "c"])(appContext, favoriteProduct.reference, product.id, currentUri) || '' : resortPageUrl.toString()
    }, renderFavorite(favoriteProduct)));
  }), !!numberOfPlaceHolders && getPlaceholders(numberOfPlaceHolders), isLogged && __jsx("div", {
    className: "flex justify-center items-center"
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_27__[/* Button */ "a"], {
    className: "mt-10",
    "data-testid": "CTA-see-more",
    onClick: function onClick() {
      trackClickEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_13__[/* TRACK_EVENT_NAMES */ "E"].CLICK_HEADER, {
        detail_click: 'travel_plans_view_more'
      });
      onClose();
    },
    type: "button",
    url: "".concat(_routes_routeBuilder__WEBPACK_IMPORTED_MODULE_17__[/* buildUrl */ "a"]('account'), "/searches")
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('common.viewMore'))));
};

var NavigationFavorite = function NavigationFavorite(_ref5) {
  var showcaseLatest = _ref5.showcaseLatest,
      onButtonClick = _ref5.onButtonClick,
      onClose = _ref5.onClose;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_8__["useContext"])(_context_FavoriteProductListContext__WEBPACK_IMPORTED_MODULE_26__[/* FavoriteProductListContext */ "a"]),
      favoriteProductList = _useContext.favoriteProductsState.favoriteProductList,
      setFavoriteProductList = _useContext.setFavoriteProductList;

  var list = favoriteProductList.filter(_price_remote_price_remote_favorite_favorite_utils__WEBPACK_IMPORTED_MODULE_39__[/* filterPreBookings */ "d"]);
  var numberOfProducts = list.length;
  var latestAddedProduct = list[numberOfProducts - 1];

  if (showcaseLatest && !!numberOfProducts) {
    return __jsx(LatestAddedProductView, {
      favoriteProduct: latestAddedProduct,
      onClose: onClose,
      onButtonClick: onButtonClick
    });
  }

  return numberOfProducts ? __jsx(AllFavoriteProductView, {
    favoriteProductList: list,
    numberOfProducts: numberOfProducts,
    onClose: onClose,
    setFavoriteProductList: setFavoriteProductList
  }) : __jsx(NoFavoritesView, {
    onClose: onClose
  });
};

/***/ }),

/***/ "7knX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExclusiveCollectionBadge; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var ExclusiveCollectionBadge = function ExclusiveCollectionBadge(_ref) {
  var className = _ref.className;
  return __jsx("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('font-bold gap-5 inline-flex items-center leading-1 shrink-0 text-12 text-initial text-ultramarine', className)
  }, __jsx("span", {
    className: "aspect-square bg-ultramarine inline-flex items-center justify-center leading-0 h-[1.65em] sm:h-[2em] rounded-full text-white w-[1.65em] sm:w-[2em]"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].DIAMOND,
    width: "0.85em"
  })), Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* t */ "h"])('common.product.exclusiveCollectionTag'));
};

/***/ }),

/***/ "SUcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductBanner; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("sMBO");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("O94r");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _exclusive_collection_badge_ExclusiveCollectionBadge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7knX");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var ProductBanner = function ProductBanner(_ref) {
  var _product$destination;

  var className = _ref.className,
      product = _ref.product;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()('flex flex-col items-start text-black', className)
  }, __jsx("span", {
    className: "flex-wrap font-sans font-semibold inline-flex gap-5 items-center order-last text-20",
    "data-testid": "ProductBlockHeader-name"
  }, product.name, product.isExplicitEC && __jsx(_exclusive_collection_badge_ExclusiveCollectionBadge__WEBPACK_IMPORTED_MODULE_3__[/* ExclusiveCollectionBadge */ "a"], {
    className: "md:mx-5"
  }), product.seasonTrad && __jsx("span", {
    className: "bg-turquoise font-bold leading-1 px-10 py-5 rounded-pill shrink-0 text-10 text-center text-white whitespace-nowrap"
  }, product.seasonTrad)), __jsx("span", {
    className: "font-sans font-semibold text-sienna text-14 truncate",
    "data-testid": "ProductBlockHeader-country"
  }, product === null || product === void 0 ? void 0 : (_product$destination = product.destination) === null || _product$destination === void 0 ? void 0 : _product$destination.country));
};

/***/ }),

/***/ "VO7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setAdultsNumber; });
/* unused harmony export updateAdult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setAttendees; });
/* unused harmony export setAdults */
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ORYz");



function setAdultsNumber(adultsNumber) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_ADULTS_NUMBER */ "e"], {
    adultsNumber: adultsNumber
  });
}

function updateAdult(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_ADULT */ "f"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}

function setAttendees(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ATTENDEES */ "d"], payload);
}

function setAdults(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ADULTS */ "c"], payload);
}



/***/ })

}]);